import * as React from "react";
const IconSearch = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" className="" viewBox="0 0 17 17" fill="none">
    <circle cx="6.05" cy="6.05" r="5.65" fill="none" stroke="currentColor" stroke-width="0.8"></circle>
    <path d="M10 10L16.364 16.364" stroke-width="0.8" stroke="currentColor"></path>
  </svg>
);
export default IconSearch;
